import { getConfig } from '@klpkonsern/appconfig';
import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klp/routing';
import type { User } from '@klp/user';

import type { BuildingTabs } from './classes';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_BYGG_UTLEIE_ENABLE: boolean;
        WEBAPP_APP_BYGG_CALENDAR_USER_ENABLE: boolean;
        WEBAPP_APP_BYGG_CALENDAR_ADMIN_ENABLE: boolean;
    }
}

// Helper functions
export const ByggModuleName = 'eiendom';

export const ByggRoutes = {
    moduleRoute: () => generateRoute([ByggModuleName]),
    list: () => generateRoute([ByggModuleName]),
    listAll: (byggNummer?: string) =>
        generateRoute([ByggModuleName, byggNummer, 'all']),
    single: (byggNummer?: string, tab?: BuildingTabs | ':tab') =>
        generateRoute([ByggModuleName, byggNummer ?? '0', tab]),
    singleKundeportal: (byggNummer?: string, tab?: BuildingTabs | ':tab') =>
        generateRoute(['kundeportal', ByggModuleName, byggNummer ?? '0', tab]),
    utleie: () => generateRoute([ByggModuleName, 'utleie']),
};

const ByggAccessAll = (): boolean => true;

export const ByggAccess = (user?: User): boolean =>
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    (user && user.isAdmin) || false;

export const ByggCalendarAccess = (user?: User): boolean => {
    const userAccess = getConfig('WEBAPP_APP_BYGG_CALENDAR_USER_ENABLE', false);
    const adminAccess = getConfig(
        'WEBAPP_APP_BYGG_CALENDAR_ADMIN_ENABLE',
        false,
    );

    if (user?.isAdmin) {
        return userAccess || adminAccess || false;
    }

    return userAccess || false;
};

export const FakturaLinkAccess = (user?: User): boolean =>
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    (user && (user.isSuperUser || user.isAdmin)) || false;

export const ByggMenuItems = [
    new SidebarMenuItem({
        route: ByggRoutes.list(),
        matchRoute: ByggRoutes.moduleRoute(),
        icon: IconName.HOUSE,
        translation: 'frontPage.buildings',
        access: ByggAccessAll,
    }),
];
